import React from "react";
import "./HeroSection.css";

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <p className="hero-badge">Find your perfect domain name</p>

          <h1>
            The Web Hosting Platform Made for Your Online Business
          </h1>

          <p className="hero-subtext">
            Search, buy and manage domains, hosting, email and security from one
            premium platform built for modern businesses.
          </p>

          <div className="hero-search-box">
            <input
              type="text"
              placeholder="Search your domain name"
              aria-label="Search domain name"
            />
            <button type="button">Search Domains</button>
          </div>

          <div className="hero-tags">
            <span>.com</span>
            <span>.in</span>
            <span>.org</span>
            <span>.net</span>
            <span>.shop</span>
          </div>
        </div>

        <div className="hero-card">
          <div className="hero-card-top">
            <span className="hero-card-label">Popular deal</span>
            <h3>gohouse.in</h3>
            <p>Fast, brandable and affordable domain for first year.</p>
          </div>

          <div className="hero-price-row">
            <div>
              <span className="old-price">₹899</span>
              <h2>₹99</h2>
              <p>for first year</p>
            </div>
            <button type="button">Buy Now</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;